import { WEEKLY_OUTCOMES_FEATURE_FLAG } from 'featureFlags/config';
import { useFeatureFlag, useParticipantsFeatureFlag } from 'featureFlags/hooks';

import { USER_MODES } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';

export const useWeeklyOutcomesFFEnabled = () => {
  const userMode = useUserMode();
  const participantEnabled = useParticipantsFeatureFlag(
    WEEKLY_OUTCOMES_FEATURE_FLAG
  );
  const myEnabled = useFeatureFlag(WEEKLY_OUTCOMES_FEATURE_FLAG);

  if (userMode === USER_MODES.dashboard) {
    return myEnabled;
  }

  return participantEnabled;
};
